import * as R from 'ramda';
import { OrderProduct, Section } from '../../orderProducts.types';
import OrderProductsBuilder, { OrderProductsGroupProps } from './OrderProductsGroupBuilder';

class OrderProductsGroupByDeliveryWindow extends OrderProductsBuilder {
  public group({ orderProducts }: OrderProductsGroupProps): Section[] {
    const groupedProducts = R.groupBy<OrderProduct>(
      (product) =>
        (product.deliveryWindow
          ? `${product.availability}${product.deliveryWindow?.id}`
          : product.availability) || '',
      orderProducts,
    );

    const groupedProductsToPairs = R.toPairs(groupedProducts);

    const sections = groupedProductsToPairs.map((items) => {
      const products = items[1]!;

      return {
        availability: products[0].availability,
        deliveryWindow: products[0].deliveryWindow,
        productsCount: products.length,
        isExpanded: true,
        products,
      };
    });
    return sections;
  }
}

export default OrderProductsGroupByDeliveryWindow;
